
const HeroStats = () => {
  return (
    <div className="flex items-center space-x-8 text-sm text-gray-500 animate-fade-in" style={{ animationDelay: '800ms' }}>
      <div className="flex items-center space-x-2">
        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
        <span>99.9% Uptime SLA</span>
      </div>
      <div className="flex items-center space-x-2">
        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
        <span>24/7 Support</span>
      </div>
      <div className="flex items-center space-x-2">
        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
        <span>Skilled System Administrators</span>
      </div>
    </div>
  );
};

export default HeroStats;
